import React from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setModal } from 'slices/modal'
import { Button } from 'components'
import { MODAL_KEYS, MY_BILLS_PAGE_TAB_LABEL, ROUTES } from 'app-constants'
import { STATICS } from 'statics'
import { LIST_ITEMS } from '../../constants'
import './style.scss'

export function Error({ isMyBillsPage }) {
  const dispatch = useDispatch()
  const { push } = useHistory()

  function handleButtonClick() {
    dispatch(setModal({ key: MODAL_KEYS.NONE }))

    if (!isMyBillsPage) push(`${ROUTES.INVOICES.PATH}#${MY_BILLS_PAGE_TAB_LABEL.BANKSLIPS}`)
  }

  function renderListItems() {
    return LIST_ITEMS.map((text, index) => (
      <div key={text} className='list-item'>
        <div className='number'>{index}</div>
        <span className='text'>{text}</span>
      </div>
    ))
  }

  return (
    <div className='container-error'>
      <div className='container-icon'>
        <STATICS.PIX_ERROR_ICON />
      </div>
      <span className='text'>Ocorreu um erro ao gerar o QrCode para pagamento via PIX.</span>
      <span className='text'>
        Você pode tentar novamente em alguns minutos ou realizar o pagamento através de{` `}
        <strong>boleto bancário</strong>
      </span>
      <div className='container-list'>{renderListItems()}</div>
      <div className='container-button'>
        <Button color='primary' onClick={handleButtonClick} className='button'>
          Pagar com boleto &gt;
        </Button>
      </div>
    </div>
  )
}
